import { createAction } from '@reduxjs/toolkit';
import * as axios from 'axios';
import {
  set_album,
  set_cart_cost,
  cart_report_setter,
  conf,
  set_cart,
  set_cart_date,
  set_cart_time_index,
  set_order_address,
  set_order_shipping,
  set_shipping_price,
  cart_fetch_finish,
  set_cart_credit,
  set_geram_wallet,
  cart_save_sanad,
  product_list_localstorage,
  offline_mode_cart,
  album_list_localstorage,
  set_city_id,
  set_gold_gram_cart_usage,
  set_cart_success_modal,
} from '../confg';

import { calculate_price_without_dis, hasDiscount, notNullAndUndefined, getOfflineCartBarcode, isSameOfflineCartItem, findOfflineCartVariant } from '../helper';
import { successAction } from './successAction';
import { errorAction } from './request_error';
import { store } from '../index';
import { ROUTES } from '../blocks/profileInfo/constant/Routes';

export const set_cart_products = createAction(set_cart);
export const set_cart_albums = createAction(set_album);
export const set_cart_report = createAction(cart_report_setter);
export const set_cart_sanad = createAction(cart_save_sanad);
export const cart_cost_setter = createAction(set_cart_cost);
export const order_address_setter = createAction(set_order_address);
export const order_city_setter = createAction(set_city_id);
export const order_shipping_setter = createAction(set_order_shipping);
export const finish_update_cart = createAction(cart_fetch_finish);
export const set_gold_gram_usage = createAction(set_gold_gram_cart_usage);
export const setCartSuccessModal = createAction(set_cart_success_modal);

const readOfflineCartProducts = () => {
  const raw = localStorage.getItem(product_list_localstorage);

  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const clearOfflineCartStorage = () => {
  localStorage.removeItem(product_list_localstorage);
  localStorage.removeItem(album_list_localstorage);
};

const buildBulkCartPayload = (array) => {
  const params = new URLSearchParams();

  array.forEach((id) => {
    if (id != null && id !== '') {
      params.append('products_array[]', String(id));
    }
  });

  return params;
};

const getBulkCartHeaders = () => ({
  'Content-Type': 'application/x-www-form-urlencoded',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

const collectOfflineCartEntries = (productsList) => {
  if (!Array.isArray(productsList)) {
    return [];
  }

  return productsList
    .map((item) => {
      const variant = findOfflineCartVariant(item);
      const productsId = variant?.id || item?.product?.id || item?.id;
      if (!productsId) {
        return null;
      }

      return {
        productsId,
        price: item.price,
      };
    })
    .filter(Boolean);
};

const hasValidAuthToken = () => {
  const token = localStorage.getItem('token');
  return token && token !== 'undefined' && token !== 'null' && token.trim() !== '' && notNullAndUndefined(token);
};

let offlineCartSyncPromise = null;

const postBasketItem = (productsId, price) => {
  const form = new FormData();
  form.append('products_id', productsId);
  form.append('final_price', price);

  return axios({
    url: conf.server_url + 'customers_basket',
    method: 'POST',
    timeout: 0,
    headers: getBulkCartHeaders(),
    data: form,
  });
};

export const syncOfflineCartToServer = () => {
  return (dispatch) => {
    if (!hasValidAuthToken()) {
      return Promise.resolve();
    }

    if (offlineCartSyncPromise) {
      return offlineCartSyncPromise;
    }

    const productsList = readOfflineCartProducts();
    const entries = collectOfflineCartEntries(productsList);

    if (entries.length === 0) {
      sessionStorage.removeItem('syncOfflineCart');
      return Promise.resolve();
    }

    clearOfflineCartStorage();
    sessionStorage.removeItem('syncOfflineCart');
    dispatch(set_cart_products([]));
    dispatch(set_cart_albums([]));
    dispatch(finish_update_cart(false));

    offlineCartSyncPromise = (async () => {
      for (const entry of entries) {
        try {
          await postBasketItem(entry.productsId, entry.price);
        } catch (error) {
          const status = error?.response?.status;
          if (status === 403 || status === 409 || status === 422) {
            continue;
          }
        }
      }

      dispatch(getBasket());
      dispatch(finish_update_cart(true));
      clearOfflineCartStorage();
    })().finally(() => {
      clearOfflineCartStorage();
      offlineCartSyncPromise = null;
    });

    return offlineCartSyncPromise;
  };
};

const finishCartAdd = (dispatch) => {
  dispatch(setCartSuccessModal(true));
  dispatch(finish_update_cart(true));
};

const handleCartRequestError = (dispatch, error) => {
  dispatch(finish_update_cart(true));
  dispatch(errorAction(error?.response?.data?.msg || 'خطا در افزودن به سبد خرید'));
  localStorage.removeItem(product_list_localstorage);
  localStorage.removeItem(album_list_localstorage);
  if (error?.response?.status === 401) {
    window.location.href = ROUTES.SIGN_IN;
  }
};

export const shipping_price_setter = (price) => {
  return (dispatch) => {
    dispatch({ type: set_shipping_price, payload: price });
    dispatch(calculate_cart_costs());
  };
};

export const mandeHesab_setter = () => {
  return (dispatch) => {
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '' && notNullAndUndefined(localStorage.getItem('token'))) {
      axios({
        url: conf.server_url + 'mandeHesab',
        method: 'GET',
        timeout: 0,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then((e) => {
          dispatch(credit_setter(e.data.pool));
          dispatch(gram_wallet_setter(e.data.geram));
        })
        .catch((e) => {
          if (e?.response?.status === 401) {
            localStorage.removeItem('token');
          }
        });
    } else {
      dispatch(credit_setter(0));
      dispatch(gram_wallet_setter(0));
    }
  };
};

export const credit_setter = createAction(set_cart_credit);
export const gram_wallet_setter = createAction(set_geram_wallet);
export const cart_date = createAction(set_cart_date);
export const cart_time_index = createAction(set_cart_time_index);

export const offline_mode = (mode) => {
  return (dispatch) => {
    if (!mode) {
      dispatch(syncOfflineCartToServer());
    }

    dispatch({ type: offline_mode_cart, payload: mode });
  };
};

export const add_basket_in_bulk = (array) => {
  if (!Array.isArray(array) || array.length === 0) {
    return () => {};
  }

  const data = buildBulkCartPayload(array);

  return (dispatch) => {
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '' && notNullAndUndefined(localStorage.getItem('token'))) {
      dispatch(finish_update_cart(false));
      axios({
        url: conf.server_url + 'customers_basket/bulk',
        method: 'POST',
        timeout: 0,
        headers: getBulkCartHeaders(),
        data,
      })
        .then((e) => {
          clearOfflineCartStorage();
          dispatch(set_cart_albums([]));
          dispatch(getBasket());
          dispatch(finish_update_cart(true));
        })
        .catch((e) => {
          dispatch(finish_update_cart(true));
          const validationMessage = e?.response?.data?.products_array?.[0];
          dispatch(errorAction(validationMessage || e?.response?.data?.msg || 'خطا در همگام‌سازی سبد خرید'));
          if (e?.response?.status === 401) {
            window.location.href = ROUTES.SIGN_IN;
          }
        });
    }
  };
};

export const add_basket = (id, price) => {
  let form = new FormData();
  form.append('products_id', id);
  form.append('final_price', price);
  if (notNullAndUndefined(localStorage.getItem('token'))) {
    return (dispatch) => {
      if (notNullAndUndefined(localStorage.getItem('token'))) {
        dispatch(finish_update_cart(false));
        const token = localStorage.getItem('token');
        if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
          axios({
            url: conf.server_url + 'customers_basket',
            method: 'POST',
            timeout: 0,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            data: form,
          })
            .then((e) => {
              finishCartAdd(dispatch);
              dispatch(getBasket());
            })
            .catch((e) => {
              handleCartRequestError(dispatch, e);
            });
        }
      }
    };
  }
};

export const add_basket_bulk = (price_array) => {
  if (!Array.isArray(price_array) || price_array.length === 0) {
    return () => {};
  }

  const data = buildBulkCartPayload(price_array);

  return (dispatch) => {
    if (notNullAndUndefined(localStorage.getItem('token'))) {
      dispatch(finish_update_cart(false));
      const token = localStorage.getItem('token');
      if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
        axios({
          url: conf.server_url + 'customers_basket/bulk',
          method: 'POST',
          timeout: 0,
          headers: getBulkCartHeaders(),
          data,
        })
          .then((e) => {
            finishCartAdd(dispatch);
            dispatch(getBasket());
          })
          .catch((e) => {
            handleCartRequestError(dispatch, e);
          });
      }
    }
  };
};

export const add_basket_offline = (product, price, albm, barcode, skipSuccessModal = false) => {
  console.log({ product, price, albm, barcode });
  return (dispatch, getState) => {
    dispatch(finish_update_cart(false));
    let productsStorage = localStorage.getItem(product_list_localstorage);
    let albums = localStorage.getItem(album_list_localstorage);

    if (!notNullAndUndefined(productsStorage)) {
      localStorage.setItem(product_list_localstorage, JSON.stringify([{ product: product, price: price, barcode: barcode, album_id: albm }]));
    } else {
      let products = JSON.parse(productsStorage);
      const variantBarcode = barcode != null ? +barcode : null;
      const existingIndex =
        variantBarcode != null ? products.findIndex((item) => getOfflineCartBarcode(item) === variantBarcode) : -1;
      const entry = { product: product, price: price, barcode: barcode, album_id: albm };

      if (existingIndex >= 0) {
        products[existingIndex] = entry;
      } else {
        products.push(entry);
      }

      localStorage.setItem(product_list_localstorage, JSON.stringify(products));
    }

    //albums set
    if (!notNullAndUndefined(albums)) {
      albums = [];
      albums.push(albm);
      localStorage.setItem(album_list_localstorage, JSON.stringify(albums));
    } else {
      albums = JSON.parse(albums);
      albums.push(albm);
      albums = [...new Set(albums)];
      localStorage.setItem(album_list_localstorage, JSON.stringify(albums));
    }

    dispatch(set_cart_albums(albums));
    dispatch(set_cart_products(readOfflineCartProducts()));

    if (skipSuccessModal) {
      dispatch(finish_update_cart(true));
      return;
    }

    finishCartAdd(dispatch);
  };
};

export const getBasket = () => {
  return (dispatch) => {
    dispatch(finish_update_cart(false));
    const token = localStorage.getItem('token');
    if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '' && notNullAndUndefined(localStorage.getItem('token'))) {
      axios({
        url: conf.server_url + 'customers_basket',
        method: 'get',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
        .then((res) => {
          let album_ids = res.data.map((basket) => basket['products']['album_id']);
          album_ids = [...new Set(album_ids)];
          dispatch(set_cart_products(res.data));
          dispatch(set_cart_albums(album_ids));
          dispatch(calculate_cart_totals(res.data));
          dispatch(finish_update_cart(true));
        })
        .catch((e) => {
          if (e?.response?.status === 401) {
            localStorage.removeItem('token');
          }
          dispatch(finish_update_cart(true));
        });
    } else {
      dispatch(finish_update_cart(true));
    }
  };
};

export const remove_product_basket = (id) => {
  return (dispatch, getState) => {
    console.log('Redux action: remove_product_basket called with id:', id);

    let user = getState().user;

    if (notNullAndUndefined(localStorage.getItem('token')) && Object.keys(user).length > 0) {
      // کاربر لاگین شده - حذف از سرور
      console.log('Removing from server for logged user');
      dispatch(finish_update_cart(false));

      const token = localStorage.getItem('token');
      if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '') {
        console.log('Making DELETE request to:', conf.server_url + 'customers_basket/' + id);

        axios({
          url: conf.server_url + 'customers_basket/' + id,
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          timeout: 30000, // 30 seconds timeout
        })
          .then((response) => {
            console.log('DELETE request successful:', response.data);

            // بررسی ساختار response
            const data = response.data;

            if (Array.isArray(data)) {
              // اگر آرایه محصولات برگشت داده شد
              let album_ids = data.map((basket) => basket?.products?.album_id).filter(Boolean);
              album_ids = [...new Set(album_ids)];

              dispatch(set_cart_albums(album_ids));
              dispatch(set_cart_products(data));
              dispatch(calculate_cart_totals(data));
            } else if (data && data.products) {
              // اگر ساختار متفاوت باشد
              dispatch(set_cart_products(data.products));
              dispatch(calculate_cart_totals(data.products));
            } else {
              // اگر response خالی باشد، سبد را دوباره بگیر
              console.log('Empty response, fetching cart again');
              dispatch(getBasket());
            }

            dispatch(successAction('محصول مورد نظر از سبد خرید شما حذف شد'));
            dispatch(finish_update_cart(true));
          })
          .catch((error) => {
            console.error('DELETE request failed:', error);

            // جزئیات بیشتر از خطا
            if (error.response) {
              console.error('Response status:', error.response.status);
              console.error('Response data:', error.response.data);

              if (error.response.status === 404) {
                dispatch(errorAction('محصول در سبد خرید یافت نشد'));
              } else if (error.response.status === 401) {
                dispatch(errorAction('لطفاً مجدداً وارد شوید'));
                // ممکن است نیاز به logout باشد
              } else {
                dispatch(errorAction('در حذف از سبد خرید مشکلی پیش آمده است'));
              }
            } else if (error.request) {
              console.error('Network error:', error.request);
              dispatch(errorAction('مشکل در اتصال به سرور'));
            } else {
              console.error('Error:', error.message);
              dispatch(errorAction('خطای غیرمنتظره در حذف محصول'));
            }

            dispatch(finish_update_cart(true));
          });
      } else {
        console.error('Invalid token');
        dispatch(errorAction('لطفاً مجدداً وارد شوید'));
        dispatch(finish_update_cart(true));
      }
    } else {
      // کاربر لاگین نشده - حذف از localStorage
      console.log('Removing from localStorage for guest user');
      dispatch(finish_update_cart(false));

      try {
        let products = localStorage.getItem(product_list_localstorage);
        let albums = localStorage.getItem(album_list_localstorage);

        if (notNullAndUndefined(products)) {
          products = JSON.parse(products);
          albums = albums ? JSON.parse(albums) : [];

          console.log('Current localStorage products:', products.length);

          const removedItem = products.find((obj) => isSameOfflineCartItem(obj, id));
          const products_new = products.filter((obj) => !isSameOfflineCartItem(obj, id));

          console.log('After filter products:', products_new.length);

          if (notNullAndUndefined(albums) && Array.isArray(albums) && removedItem) {
            const albumId = removedItem.album_id || removedItem.product?.id;
            const stillHasAlbum = products_new.some((item) => (item.album_id || item.product?.id) === albumId);

            if (!stillHasAlbum) {
              const updatedAlbums = albums.filter((a) => a !== albumId);
              localStorage.setItem(album_list_localstorage, JSON.stringify(updatedAlbums));
              dispatch(set_cart_albums(updatedAlbums));
            }
          }

          // ذخیره محصولات جدید
          localStorage.setItem(product_list_localstorage, JSON.stringify(products_new));

          // بروزرسانی Redux state برای localStorage
          dispatch(set_cart_products(products_new));

          dispatch(successAction('محصول از سبد خرید حذف شد'));
          dispatch(finish_update_cart(true));
        } else {
          console.log('No products in localStorage');
          dispatch(finish_update_cart(true));
        }
      } catch (error) {
        console.error('localStorage operation failed:', error);
        dispatch(errorAction('خطا در حذف از سبد خرید'));
        dispatch(finish_update_cart(true));
      }
    }
  };
};

export const calculate_cart_totals = (products) => {
  return (dispatch, getState) => {
    let user = getState().user;
    let discount_total = 0;
    let ojrat_total = 0;
    let kasr_total = 0;
    let total_price = 0;
    let total_weight = 0;

    products.map((product, i) => {
      let has_discount = hasDiscount(product['discount']);

      if (Object.entries(user).length !== 0 && user['is_teammate']) {
        let $kasr = (product['formula']['k'] * product['products']['accounting_weight']) / 100;
        let $kasr_with_discount = has_discount ? ((product['formula']['k'] - product['discount']['percent']) * product['products']['accounting_weight']) / 100 : 0;
        let $ojrat = product['formula']['o'] * product['products']['accounting_weight'];
        let discount = has_discount ? $kasr - $kasr_with_discount : 0;
        total_weight = total_weight + product['products']['accounting_weight'];
        discount_total = discount_total + discount;
        ojrat_total = ojrat_total + $ojrat;
        kasr_total = kasr_total + $kasr;
        let price = product['final_price'] / 10;
        total_price = total_price + price;
      } else if (Object.entries(user).length !== 0 && !user['is_teammate']) {
        const state = store.getState();
        let p = state.gold_price;
        let price = product['final_price'];
        let discount = has_discount ? calculate_price_without_dis(p, product['formula'], product['products']['accounting_weight'], 0) - price : 0;
        total_price = parseFloat(total_price) + parseFloat(price) / 10;
        discount_total = discount_total + discount;
      }

      return null;
    });

    dispatch(
      set_cart_report({
        total_kaser: parseFloat(kasr_total).toFixed(3),
        total_make_pay: parseFloat(ojrat_total).toFixed(2),
        total_gr: (parseFloat(total_weight) + parseFloat(kasr_total)).toFixed(3),
        total_price: parseFloat(total_price).toFixed(0),
        total_discount: parseFloat(discount_total).toFixed(2),
        total_weight: parseFloat(total_weight).toFixed(3),
      }),
    );

    dispatch(calculate_cart_costs());
  };
};

/*this user for final calculation*/
export const calculate_cart_costs = () => {
  return (dispatch, state) => {
    let total_weight_to_pay = null;
    let total_money_to_pay = null;
    let usr = state().user;
    let cart_report = state().cart.cart_report;
    let shipping_price = state().cart.price_shipping;

    if (usr['is_teammate']) {
      total_weight_to_pay = parseFloat(cart_report['total_kaser']) + parseFloat(cart_report['total_make_pay']);
      total_money_to_pay = parseFloat(cart_report['total_make_pay']);
    } else {
      total_money_to_pay = parseFloat(cart_report['total_price']) + parseFloat(shipping_price);
    }

    dispatch(cart_cost_setter({ total_weight_to_pay: parseFloat(total_weight_to_pay).toFixed(2), total_money_to_pay: parseFloat(total_money_to_pay).toFixed(2) }));
  };
};

export const set_all_default = () => {
  return (dispatch, state) => {
    dispatch(cart_date(null));
    dispatch(cart_time_index(null));
    dispatch(order_shipping_setter(null));
    dispatch(order_address_setter(null));
    dispatch(order_city_setter(null));
  };
};
